//Clone of m22 GameStatistics

import React from "react";
import "./index.scss";

import { processStatisticsPercentage } from "@/modules/statistics";
import { IStatisticsArray } from "@/types/StatisticsTypes";
import { ILongerGameStatisticsProps } from "@/types/LongerStatisticsTypes";

interface IProps extends ILongerGameStatisticsProps {
	listed: boolean;
}

export default class M25 extends React.Component<IProps> {
	statisticsArray: IStatisticsArray;

	filtrate(history) {
		let odds = 0, evens = 0;
		
		const listed = this.props.listed;
		const colours = ["white", "green", "yellow", "red"];

		const total = history.length;
		
		const nums = {1: 0, 2: 0, 3: 0, 4: 0};
		
		//Multi Table
		if (listed) { 
			// "5736876938775226949669154299527788166985114111314486925892962195511124571654".split("")
			history.forEach(item => {
				nums[parseInt(item.angka, 10)]++;
			});
			
			this.statisticsArray.top.push(...colours.map((colour, idx) =>
				<div key={`m25gst_${idx}`} className={`sl-roadmap-circle ${colour}-bg`}>
					{idx + 1}
				</div>
			));
			
			this.statisticsArray.bottom.push(...colours.map((colour, idx) =>
				processStatisticsPercentage(`m25gsb_${idx}`, nums[idx + 1], total)
			));
			
		} else {
			//Single game
			
			// "5736876938775226949669154299527788166985114111314486925892962195511124571654".split("")
			history.forEach(item => {
				if (parseInt(item.angka, 10) % 2)
					odds++;
				else evens++;
			});
			
			this.statisticsArray.top.push(...[
				<div key="m25gst_4" className="sl-roadmap-circle red-bg">O</div>,
				<div key="m25gst_5" className="sl-roadmap-circle blue-bg">E</div>
			]);
			
			this.statisticsArray.bottom.push(...[
				<div key="m25gsb_4">{odds}</div>,
				<div key="m25gsb_5">{evens}</div>
			]);
		}
	}

	render() {
		this.statisticsArray = {top: [], bottom: []};

		if (!this.props.history)
			return null;

		this.filtrate(this.props.history);
	
		return (
			<div className="game-statistics m25">
				<div className="new-statistics top">
					{ this.statisticsArray.top }
				</div>
				<div className="new-statistics">
					{ this.statisticsArray.bottom }
				</div>
			</div>
		);
		// return renderm25Statistics(this);
	}
}